import axios from "axios";
import { Toast } from "vant";
import Router from "@/router/index";
import { encrypt } from "@/libs/aes";

import DialogBox from "@/components/base/dialog/iconDialog.js";
import { timestampEncryConfig } from "@/config/timestampEncryConfig";
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 30000,
});
axios.defaults.headers.post["Content-Type"] = "application/json;charset=UTF-8";

// 请求拦截
service.interceptors.request.use(
    (config) => {
        if (config.method === "post") {
            config.data = config.data instanceof FormData ? config.data : config.data;
        }
        config.data = { ...config.data, userId: localStorage.getItem("userId") };
        let timeStamp = encodeURIComponent(encrypt(new Date().getTime(), timestampEncryConfig.field));
        // 每次请求头都加上token，不放cookie的原因是微信浏览器有时候拿不到cookie
        config.url += `?token=${localStorage.getItem("token")}&timestamp=${timeStamp}`;

        return config;
    },
    (error) => {
        console.log(error);
        return Promise.reject(error);
    }
);
// 响应拦截
service.interceptors.response.use(
    (response) => {
        const res = response.data;

        //状态码不为200 600就抛出
        if (res.code !== 200) {
            //token无效 跳转到登录页
            if (res.code === 600) {
                wx.miniProgram.redirectTo({
                    url: `/pages/login/login?type=loginout`,
                });
            } else if (res.code !== 600) {
                DialogBox({
                    type: "fail",
                    content: `<div>${res.msg || "error"}</div> `,
                });
            }
            return Promise.reject(new Error(res.message || "Error"));
        } else {
            return res;
        }
    },
    (error) => {
        console.log("err" + error); // for debug
        Toast({
            message: error.message,
        });
        return Promise.reject(error);
    }
);

export default service;
